export const SITE_TYPES = {
  COLLEGE: 'College',
  GRADES_9_12: '9-12',
  GRADES_6_8: '6-8',
  GRADES_K_5: 'K-5',
  INTERNATIONAL: 'International',
  OTHER: 'Other',
}
